﻿export class UserSocialMediaModel{
    Id: number = 0;
    AppName: string = "";
    AppType: string = "Social Media";
    Url: string = "";
    UserId: number = 0;
}